import { ProductOption } from '../apis/models/products/res/ProductOption';
import { ProductOptionExhibition } from '../apis/models/reservations/req/AddReservationBody';
import { UnavailableProductOptionData } from '../apis/models/reservations/res/UnavailableProductOption';

export const toProductOptionExhibitions = (
  productOptions: ProductOption[],
): ProductOptionExhibition[] =>
  productOptions.flatMap(({ id, exhibitionId }) =>
    exhibitionId === undefined || exhibitionId === null
      ? []
      : [{ productOptionId: id, exhibitionId }],
  );

// 서버가 거절한 항목 중 제출 시점 스냅샷에 있던 옵션 ID만 반환한다.
// 같은 옵션이라도 기획전 ID가 다르면 현재 선택으로 보지 않는다.
export const getRejectedProductOptionIds = (
  submittedOptions: ProductOption[],
  data: UnavailableProductOptionData,
): number[] =>
  submittedOptions
    .filter((option) =>
      data.items.some(
        (item) =>
          item.productOptionId === option.id &&
          item.exhibitionId === (option.exhibitionId ?? null),
      ),
    )
    .map(({ id }) => id);
